import { Capacitor } from '@capacitor/core';
import store from '@/store/index';
import { PushNotifications } from '@capacitor/push-notifications';

// ----------------------------- o

export default {
    async pushInit() {

        return new Promise((resolve, reject) => {

            // Request permission to use push notifications
            // iOS will prompt user and return if they granted permission or not
            // Android will just grant without prompting
            PushNotifications.requestPermissions().then(result => {
                if (result.receive === 'granted') {
                    console.log('granted')
                    // Register with Apple to receive push via APNS
                    if (Capacitor.platform == 'ios') {
                        PushNotifications.register();
                    }else if(Capacitor.platform == 'android'){
                        setTimeout(() => {
                            PushNotifications.register().catch((error) => reject(error))
                            resolve()
                        }, 2500);
                    }
                } else {
                    reject()
                    // TODO show some error?
                }
            });

            // On success, we should be able to receive notifications
            PushNotifications.addListener('registration',
                (token) => {
                    store.dispatch('AUTH_SAVE_DEVICE_TOKEN', token.value);
                    resolve()
                }
            );

            // Some issue with our setup and push will not work
            PushNotifications.addListener('registrationError',
                (error) => {
                    console.log('Error on registration: ' + JSON.stringify(error));
                }
            );

            // Show us the notification payload if the app is open on our device
            PushNotifications.addListener('pushNotificationReceived',
                (notification) => {
                    console.log('Push received: ' + JSON.stringify(notification));
                    store.dispatch('GLOBAL_TOAST', notification.title + ' ' + notification.body);
                    resolve()
                }
            );

            // Method called when tapping on a notification
            PushNotifications.addListener('pushNotificationActionPerformed',
                (notification) => {
                    console.log('Push action performed: ' + JSON.stringify(notification));
                }
            );

        })

    }
};